// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mc-footer[data-v-b4fd56e6] {\n  margin-top: 20px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  text-align: center;\n}\n.mc-footer p[data-v-b4fd56e6] {\n  margin-bottom: 2px;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
